angular
  .module("frontPageTemplateDirective", [])
  .controller("dpController", [function () {}])
  .directive("dpElement", [
    "$compile",
    "$http",
    "$templateCache",
    "$parse",
    function ($compile, $http, $templateCache, $parse) {
      return {
        restrict: "AE",
        scope: {
          payload: "=",
          type: "@",
        },
        link: function (scope, element, attrs) {
          if (attrs.type) {
            scope.templateToUse =
              "template/elements/element-" + attrs.type + ".html";
          }
        },
        template: "<div ng-include='templateToUse'></div>",
      };
    },
  ]);
